// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M13 8H8H3'];
